<script>
  /*   import { preguntas,updateD,delDoc } from "../../stores/CES"; */
  /* import {inputdate as input} from "../../components/input/advanced"
  import {inputdate} from "../../components/input/daterangepicker" */
  import { navigate } from "svelte-routing";
  import { userRol } from "../../stores/user";
  import { onMount } from "svelte";
  import {
    modalStore,
    dataEdit,
    viewsData,
    addDoc,
    updateD,
    panelController,
    getInt,
    modalS,
    updateService,
  } from "../../stores/service";
  document.title = "Rantingg | Menu";
  /*"../../plugins/daterangepicker/daterangepicker.js*/
  let dataList = [];

  let resp = 0;
  onMount(async () => {
    if ($panelController.viewPanel.status) {
      document.title = `Lista de ratinggs ! ${$panelController.service.listRatinggs[$panelController.viewPanel.index[0]].config.name}`;
    } else {
      navigate("/main-ratinggs", { replace: true });
    }

    switch ($dataEdit.opc) {
      case 300:
        document.title = "Ratingg | Lista de ratinggs";
        dataList = $dataEdit.data;
        break;

      default:
        break;
    }
  });

  async function control(o, i) {
    switch (o) {
      case 1:
        $modalS.reset();
        $modalS.info.title = "Aviso";
        $modalS.info.body = `Desea eliminar el ratingg ${$panelController.service.listRatinggs[$panelController.viewPanel.index[0]].rattings[i].pregunta}`;
        $modalS.controllers.btn[0].text = `Si, quiero`;
        $modalS.controllers.btn[1].text = `No, cancelar`;
        $modalS.controllers.btn[0].status = true;
        $modalS.controllers.btn[1].status = true;

        let modal = await $modalS.mostrar();
        if (modal) {
          $panelController.service.listRatinggs[
            $panelController.viewPanel.index[0]
          ].rattings.splice(i, 1);
          $panelController.viewCE.nav = true;
          updateService();
        }
        /* console.log('value delete -->',$panelController.service.listRatinggs[$panelController.viewPanel.index[0]].rattings[i].pregunta); */

        break;

      case 2:
        $panelController.viewCE.index = [
        $panelController.viewPanel.index[0],
          i,
        ];
        $panelController.viewCE.status = true;
        $panelController.viewCE.nav = true;
        $panelController.viewCE.opc = 2;
        navigate("/CE", { replace: true });
        break;

      case 3:
        $panelController.viewCE.status = true;
        $panelController.viewCE.nav = true;
        $panelController.viewCE.opc = 1;
        $panelController.viewCE.name =
          $panelController.service.listRatinggs[
            $panelController.viewPanel.index[0]
          ].config.name;

        $panelController.viewCE.index = [
          $panelController.viewPanel.index[0],
          $panelController.service.listRatinggs[
            $panelController.viewPanel.index[0]
          ].rattings.length + 1,
        ];
        $panelController.viewCE.opc = 1;

        navigate("/CE", { replace: true });
        break;

      case 4:
        $panelController.viewOrdenar.status = true;
        $panelController.viewOrdenar.nav = true;
        $panelController.viewOrdenar.index = [
        $panelController.viewPanel.index[0],
          0
        ];

        navigate("/orden", { replace: true });
        break;

      default:
        break;
    }
  }
</script>

{#if $panelController.viewPanel.status}

  <button
    type="button"
    class="btn btn-outline-primary"
    on:click={() => control(3)}
    on:click={() => navigate("/CES", { replace: true })}>
    <i class="bi bi-plus-circle"></i>
    Nuevo</button
  >

  <button
    type="button"
    class="btn btn-outline-primary"
    on:click={() => control(4)}
    on:click={() => navigate("/orden", { replace: true })}>
    <i class="bi bi-wrench"></i>
    Ordenar</button
  >


<div class="card text-center">
  <div class="card-header">
    {$panelController.service.listRatinggs[$panelController.viewPanel.index[0]]
      .config.name}
  </div>
  <div class="card-body">
    <div class="row">
      <div class="form-group col-1">
        <label for="numero1">N.</label>
      </div>
      <div class="form-group col-4">
        <label for="numero1">Pregunta</label>
      </div>
      <div class="form-group col-3">
        <label for="numero2">Tipo</label>
      </div>
      <div class="form-group col-4">
        <label for="numero2">Acciones</label>
      </div>
    </div>
    {#each $panelController.service.listRatinggs[$panelController.viewPanel.index[0]].rattings as item, index}
      <div class="row">
        <div class="form-group col-1">
          <p>{index + 1}</p>
        </div>

        <div class="form-group col-4">
          <p>{item.pregunta}</p>
        </div>

        <div class="form-group col-3">
          {#if item.tipo == 1}
            <p>Multiple</p>
          {/if}
          {#if item.tipo == 2}
            <p>3 opciones</p>
          {/if}
          {#if item.tipo == 3}
            <p>Rango</p>
          {/if}
          {#if item.tipo == 4}
            <p>Normal</p>
          {/if}
        </div>
        
          <div class="form-group col-4">
            <button
              type="button"
              class="btn btn-outline-danger m-1"
              on:click={() => control(1, index)}>
              Eliminar
              <i class="bi bi-trash"></i>
              </button
            >
            <button
            type="button"
            class="btn btn-outline-primary m-1"
            on:click={() => control(2, index)}
            >Editar
            <i class="bi bi-pencil-square"></i>
          </button>
          </div>

      </div>
    {/each}
  </div>

</div>

{/if}